import { render, staticRenderFns } from "./projectReviews.vue?vue&type=template&id=0e76d212&scoped=true&"
import script from "./projectReviews.vue?vue&type=script&lang=js&"
export * from "./projectReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e76d212",
  null
  
)

export default component.exports